// components/CustomScriptInjector/extract.ts — Extract <script> tags from content
export interface ScriptData {
    src?: string;
    code?: string;
}

export const extractScripts = (content: string): ScriptData[] => {
    const scripts: ScriptData[] = [];
    const scriptTagRegex = /<script\b([^>]*)>([\s\S]*?)<\/script>/gi;
    let match;

    while ((match = scriptTagRegex.exec(content))) {
        const attrs = match[1] || '';
        const code = match[2]?.trim();
        const srcMatch = attrs.match(/src=['"]([^'"<>]+)['"]/i);
        scripts.push({ src: srcMatch?.[1], code });
    }

    // If no <script> tag is found, treat the whole content as inline code
    if (scripts.length === 0 && content.trim()) {
        scripts.push({ code: content.trim() });
    }

    return scripts.filter(s => s.src || s.code);
};
